
import { MemberType } from '@/types/entities'

import { defineComponent, PropType } from 'vue'
import Avatar from '@/components/Avatar.vue'
import ActionButton from './ActionButton.vue'
import WorkspaceDropdown from './WorkspaceDropdown.vue'
export default defineComponent({
  props: {
    members: {
      type: Array as PropType<MemberType[]>,
      default: (): Array<[]> => []
    },
    size: {
      type: String,
      default: 'small',
      validator: (v: string) => ['medium', 'small'].includes(v)
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  components: {
    Avatar,
    ActionButton,
    WorkspaceDropdown
  },
  data () {
    return {
      showMoreMembers: false
    }
  },
  computed: {
    memberAvatars () {
      return this.members.slice(0, this.limit)
    },
    limited () {
      return this.members.length - this.limit
    }
  }
})
